import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import Locize from "i18next-locize-backend";
import LanguageDetector from "i18next-browser-languagedetector";

const projectId = "e54181f0-c2de-4f0b-90ce-84d5df542424";
const nodeEnv = process.env.NODE_ENV || 'test';

if (nodeEnv !== 'test') {
    i18n
        .use(Locize)
        .use(LanguageDetector)
        .use(initReactI18next)
        .init({
            load: 'currentOnly',
            supportedLngs: ['nb-NO', 'nn-NO', 'sv', 'en'],
            fallbackLng: 'nb-NO',
            debug: nodeEnv === "development",
            interpolation: {escapeValue: false},
            saveMissing: true,
            backend: {
                projectId: projectId,
                apiKey: window._env_.REACT_APP_LOCIZE_API_KEY,
                referenceLng: "nb-NO",
                fallbackLng: "nb-NO",
                allowedAddOrUpdateHosts: ["localhost"],
                version: 'latest',
                cdnType: 'pro',
            },
            ns: ['translation', 'dams.document'],
            defaultNS: 'translation',
            lng: 'nb-NO'
        });
} else {
    i18n
        .use(initReactI18next)
        .init({
            fallbackLng: 'no',
            debug: false,
            interpolation: {escapeValue: false},
            ns: ['translation', 'dams.document'],
            defaultNS: 'translation',
            resources: {"nb-NO": {translation: {}, "dams.document": {}}}
        });
}

export default i18n;
